module.exports = __webpack_public_path__ + "media/images/smart_phone/products/kamasu1-94ca3641db40fb83de8f90144dfbe95d.jpeg";